(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/lyckoplatsen/components/shared-map/assets/javascripts/map-mini.js') >= 0) return;  svs.modules.push('/modules/lyckoplatsen/components/shared-map/assets/javascripts/map-mini.js');

'use strict';

function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
const {
  swe,
  sweRectangleBounds,
  mapDefaults,
  createMap,
  calculateCumulativeSumDoubledUpToIndex,
  calculateSouthCoordinate,
  isPointInsideSweden,
  get3dPinIcon,
  checkDuplicateWagersLocations
} = svs.tur.lyckoplatsen.map;
function getMiniMapHandler() {
  let map;
  let options;
  let wagers;
  let sweRec;
  const gridCoords = [];
  const rads = []; 
  const leafletWagers = [];
  return {
    createMap(mapOptions) {
      let mapWagers = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
      options = _objectSpread(_objectSpread({}, mapDefaults), mapOptions);
      map = createMap(options);
      wagers = mapWagers;
      if (mapWagers.length) {
        this.setupWagers(mapWagers);
      }
      sweRec = leaflet.rectangle(sweRectangleBounds, {
        color: 'yellow',
        fillOpacity: 0.6,
        weight: 1
      });
      map.fitBounds(sweRec.getBounds(), {
        padding: [0, 0],
        animate: false
      });
      this.initiateMiniMap();
      return map;
    },
    setupWagers(mapWagers) {
      const uniqueWagersLocations = checkDuplicateWagersLocations(mapWagers);
      wagers = uniqueWagersLocations;
    },
    removeMap() {
      leafletWagers.forEach(pin => {
        try {
          if (pin && pin.remove) {
            pin.remove();
          }
        } catch (err) {
        }
      });
      leafletWagers.length = 0;

      if (sweRec && sweRec.remove) {
        try {
          sweRec.remove();
        } catch (err) {
        }
        sweRec = null;
      }

      if (map) {
        try {
          map.off();
          map.remove();
        } catch (err) {
        }
        map = null;
      }

      gridCoords.length = 0;
      rads.length = 0;
      wagers = null;
      options = null;
    },

    addDots() {
      let skipCheck = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
      let orgCoords;
      let lat;
      let lng;
      const rows = 57;
      const cols = 26; 

      const latDiff = (sweRectangleBounds[0][0] - sweRectangleBounds[1][0]) / rows;
      const lngDiff = (sweRectangleBounds[0][1] - sweRectangleBounds[1][1]) / cols;

      for (let i = 0; i < rows; i++) {
        if (i === 0) {
          lat = sweRectangleBounds[0][0] - i * latDiff - latDiff / 2;
        } else {
          const distanceFromStart = calculateCumulativeSumDoubledUpToIndex(rads, i - 1).pop();
          const newLatCoord = calculateSouthCoordinate(orgCoords, distanceFromStart);
          lat = newLatCoord[0];
        }

        const lng1 = sweRectangleBounds[0][1] - Number(lngDiff) - lngDiff / 2;
        const lng2 = sweRectangleBounds[0][1] - 2 * lngDiff - lngDiff / 2;
        const rowRadius = map.distance([lat, lng1], [lat, lng2]) / 2;
        rads.push(Number(rowRadius.toFixed(0)));

        for (let j = 0; j < cols; j++) {
          lng = sweRectangleBounds[0][1] - j * lngDiff - lngDiff * 0.4; 

          if (i === 0) {
            orgCoords = [lat, lng]; 
          }
          let dotName = '';
          if (skipCheck || isPointInsideSweden([lat, lng], swe.features[0].geometry.coordinates)) {
            dotName = "gsap-dot-sweden gsap-dot-".concat(i);
            lat = Number(lat.toFixed(6));
            lng = Number(lng.toFixed(6));

            leaflet.circle([lat, lng], {
              radius: rads[i] * 0.84,
              fillColor: '#2073E5',
              fillOpacity: 1,
              weight: 0,
              className: "gsap-dot ".concat(dotName)
            }).addTo(map);
            gridCoords.push({
              lat,
              lng,
              radius: Number(rowRadius.toFixed(0))
            });
          }
        }
      }
    },
    addWagers() {
      if (!wagers.length) {
        return;
      }
      wagers.forEach((wager, index) => {
        const icon = get3dPinIcon({
          className: "gsap-pin-wager-mini gsap-pin-wager-mini-".concat(index),
          color: 'red',
          useSmallIcon: true,
          count: wager.wagerMultiplayed
        });
        const formattedLat = parseFloat(wager.wager.bets[0].geoBoardData.geoLoc.latitude.replace(',', '.')).toFixed(6);
        const formattedLng = parseFloat(wager.wager.bets[0].geoBoardData.geoLoc.longitude.replace(',', '.')).toFixed(6);
        const pin = leaflet.marker([formattedLat, formattedLng], {
          icon
        });
        pin.setZIndexOffset((index + 1000) * (wager === null || wager === void 0 ? void 0 : wager.wagerMultiplayed));
        pin.addTo(map);
        leafletWagers.push(pin);
      });
    },
    initiateMiniMap() {
      this.addDots();
      this.addWagers();
    }
  };
}
Object.assign(svs.lyckoplatsen.components.shared_map, {
  getMiniMapHandler
});

 })(window);